import { useRoutes } from 'react-router-dom';

// routes
import getMainRoutes from './MainRoutes';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
    return useRoutes([getMainRoutes()]);
}
